module.exports = __webpack_public_path__ + "src/assets/img/star-home.8b5bc45e.svg";